/**
 * TEMU 店铺同步（模板库·运费模板 / 发货仓 / 模特等）错误文案归一。
 *
 * 平台原始报错对卖家没有可操作性（例如发货仓的
 * `Temu API failed type=bg.btg.goods.stock.warehouse.list.get errorCode=3000000: 不能为空,个数必须在1和50之间;`），
 * 这里按错误码翻译成「下一步该做什么」，未识别的错误码仍原样透出，避免吞掉真实原因。
 */

import i18n from '@/i18n';

export const SYNC_SECTION_LABELS = {
  mallInfo: '基本信息',
  accessTokenInfo: '授权信息',
  brands: '品牌',
  categories: '可发类目',
  freightTemplates: '运费模板',
  warehouses: '仓库/站点',
  models: '模特',
};

function sectionLabel(sectionKey) {
  return SYNC_SECTION_LABELS[sectionKey] || sectionKey;
}

/** 将平台 7000019 / 7000016 / 3000000 等错误转成可操作提示 */
export function formatShopSyncSectionError(sectionKey, raw) {
  const msg = String(raw || '').trim();
  if (!msg) return '';
  const lower = msg.toLowerCase();
  const noApiAccess = lower.includes('7000019')
    || lower.includes("don't have this api access")
    || lower.includes('authorize this api');
  if (noApiAccess) {
    if (sectionKey === 'models') {
      return i18n.t('modelLib.noAccess', { ns: 'workbench' });
    }
    if (sectionKey === 'brands') {
      return '当前店铺未授权品牌查询接口。请到 TEMU 卖家中心开通「货品API组」品牌权限并重新授权。';
    }
    if (sectionKey === 'freightTemplates') {
      return i18n.t('freightLib.noAccess', { ns: 'workbench' });
    }
    if (sectionKey === 'warehouses') {
      return i18n.t('warehouseLib.noAccess', { ns: 'workbench' });
    }
    return `当前店铺未授权「${sectionLabel(sectionKey)}」相关接口，请到卖家中心开通权限并重新授权。`;
  }
  if (lower.includes('7000016') || lower.includes('type not exists')) {
    return `平台返回 7000016（type not exists）：接口 type 传值错误或不在本区，不是权限问题（权限不足是 7000019）。请确认「${sectionLabel(sectionKey)}」对应 type 与网关（已迁移须走 PA）。`;
  }
  // 3000000：siteIdList 必填 1~50 的平台侧报错。后端已按店铺站点/货品 bindSiteIds/官方站点目录回退，
  // 走到这里说明店铺确实没有任何可用站点。
  if (lower.includes('3000000') || lower.includes('个数必须在1和50之间')) {
    if (sectionKey === 'warehouses') {
      return i18n.t('warehouseLib.needSites', { ns: 'workbench' });
    }
    return `平台返回 3000000（参数个数不合法）：请检查「${sectionLabel(sectionKey)}」同步入参后重试。`;
  }
  return msg;
}
